import AddLinkIcon from '@mui/icons-material/AddLink';
import IconButton from '@mui/material/IconButton';
import { ReactElement, useState } from 'react';
import { Button, ButtonProps, Labeled, useResourceContext, useTranslate } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import LinkInputModal from './LinkInput/LinkInputModal';
import LinkInputPreview from './LinkInput/LinkInputPreview';
import { HandleSelectClick } from './LinkInput/types';

interface LinkInputModalInputProps extends Omit<ButtonProps, 'children'> {
  icon: ReactElement;
  source?: string;
  buttonOnly?: boolean;
  hideLabel?: boolean;
  // onSelect?: (fileManagerSelect: FileManagerSelect) => void;
}

const LinkInput = ({ ...props }: LinkInputModalInputProps) => {
  const { label = 'ra.action.links_manager', icon, source, buttonOnly, hideLabel } = props;
  const translate = useTranslate();
  const [showDialog, setShowDialog] = useState(false);
  const resource = useResourceContext();
  const formContext = useFormContext();
  const { setValue,  } = formContext ? formContext : { setValue: (_n: string, _v: any) => { } };

  const onClick = () => {
    setShowDialog(true);
  }

  const handleSelectClick: HandleSelectClick = (selection: Array<any>, lang: string, url) => {
    if (source) {
      setValue(source, 0 === selection.length ? null : {node: selection[0], lang, url}, { shouldDirty: true });
    }
    setShowDialog(false);
  }

  const handleCloseClick = () => {
    setShowDialog(false);
  }

  return (
    <>
      {!buttonOnly
        ? !hideLabel
          ? <Labeled label={translate(`resources.${resource}.fields.${source}`)}>
            <Button label={translate(label)} onClick={onClick} {...props}>{icon}</Button>
          </Labeled>
          : <Button label={translate(label)} onClick={onClick} {...props}>{icon}</Button>
        : <IconButton onClick={onClick}>{icon}</IconButton>
      }
      {source && <LinkInputPreview source={source} />}
      <LinkInputModal showDialog={showDialog} handleSelectClick={handleSelectClick} handleCloseClick={handleCloseClick} label={label} />
    </>
  );
}

LinkInput.defaultProps = {
  label: 'ra.action.links_manager',
  title: '',
  icon: <AddLinkIcon />,
}

export default LinkInput;
export { LinkInputModal };
